import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-m', 'IconLetterM', [["path",{"d":"M6 20v-16l6 14l6 -14v16","key":"svg-0"}]]);